import { render, staticRenderFns } from "./PageConfig.vue?vue&type=template&id=4a5a5689&scoped=true"
import script from "./PageConfig.vue?vue&type=script&lang=js"
export * from "./PageConfig.vue?vue&type=script&lang=js"
import style0 from "./PageConfig.vue?vue&type=style&index=0&id=4a5a5689&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a5689",
  null
  
)

export default component.exports